<template>
  <el-dialog
    class="passport-unlock-modal"
    width="90%"
    title="账户解禁"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <form v-loading="loading" class="respone-form">
      <div class="field">
        <el-select v-model="context.lockType" placeholder="解封类型">
          <el-option label="单日次数上限" :value="1"></el-option>
          <el-option label="接口比例上限" :value="2"></el-option>
          <el-option label="VIN次数上限" :value="3"></el-option>
          <el-option label="IP数量上限" :value="4"></el-option>
          <el-option label="操作过快" :value="5"></el-option>
        </el-select>
      </div>
      <div class="field" v-if="context.lockType === 5">
        <el-input v-model="context.ip" placeholder="解封IP" />
      </div>
      <div class="field" v-else>
        <el-input v-model="context.userName" placeholder="用户手机号" :maxlength="11" />
      </div>
      <div class="actions">
        <el-button type="primary" size="small" @click="doSubmit">确定</el-button>
        <el-button type="default" size="small" @click="close(false)">取消</el-button>
      </div>
    </form>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { UnlockPassport } from '../services'
import _ from 'lodash'
export default {
  name: 'PassportUnlockModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      context: {
        userName: '',
        lockType: 1,
        ip: ''
      }
    }
  },
  created () {
    this.debounceRequest = _.debounce(() => {
      UnlockPassport(this.context).then((resp) => {
        this.$message.success(JSON.stringify(resp))
        this.close(true)
      })
    }, 5000, {
      leading: true,
      trailing: false
    })
  },
  methods: {
    init () {
      return this.open()
    },
    checkModel () {
      return new Promise((resolve, reject) => {
        const { userName, lockType, ip } = this.context
        if (lockType === 5) {
          if (!ip) {
            reject(new Error('请输入用户名'))
          }
        } else if (!userName) {
          reject(new Error('请输入用户名'))
        }
        resolve(true)
      })
    },
    doSubmit () {
      this.checkModel().then(() => {
        this.debounceRequest()
      }).catch((err) => {
        this.$message.error(err.message)
      })
    }
  }
}
</script>
<style lang="stylus">
.passport-unlock-modal
  .el-dialog
    max-width 800px
    .el-dialog__body
      padding-top 10px
      .field
        .el-select
          width 100%
        +.field
          margin-top 12px
    .actions
      margin-top 12px
      text-align center
</style>
